import React from 'react';
import styled from 'styled-components';

export default styled.h1`
  text-align: center;
  margin-bottom: 1rem;
`;



// WEBPACK FOOTER //
// ./src/components/styledComponents/SubHeader.js